'use strict';
var app = angular
    .module('app', [
        'ui.router',
        'ui.bootstrap',
        'ngAnimate',
        'validation',
        'validation.rule',
        'LocalStorageModule',
        'angular.filter',
        'treeControl',
        'pasvaz.bindonce',
        'cgBusy',
        // 'ngFlowGrid',
        'ui.router',
        'appRouterModule',
        'headModule',
        // 'loginModule',
        'manageConfig',
        'myZoneModule',
        'editingCenterModule',
        'operateCenterModule',
        'webIMModule',
        'infinite-scroll',
        'components.service',
        'components.filter',
        'components.util',
        'components.directive',
        'templates-main',
        'duScroll',
        'noticeOfPassDraftModule',
        'cloudModule',
        'planningCenterModule',
        'resourceCenterModule', // 版权资源模块
        'networkSourceCenterModule', // 网络资源模块
        'planningResourceModule', // 老的策划资源，挂了一个指挥监测，暂时先放着
        'messageCenterModule',
        'IMModule', // im聊天模块
        'feedBackModule', // 意见反馈模块
        'messageNotifyModule',
        'dateReminderModule', // 日期提醒模块
        'ngSessionStorage',
        'daterangepicker', // 新增时间选择器
        // 'ngCookies',
    ])
    .config([
        '$validationProvider',
        function ($validationProvider) {
            $validationProvider.setSuccessHTML(function (msg) {
                return '';
            });
            $validationProvider.setErrorHTML(function (msg) {
                // remember to return your HTML
                return '<p class="validation-invalid">' + msg + '</p><i></i>';
            });
        },
    ]) // 将http的提交参数调整成form的方式
    .config([
        '$httpProvider',
        function ($httpProvider) {

            /**
             * [toFormData description] converts an object to x-www-form-urlencoded serialization.
             * @param   {[type]}  obj  [obj description]
             * @return  {[type]}       [return description]
             */
            function toFormData(obj) {
                var query = '';
                var name, value, fullSubName, subName, subValue, innerObj, i;
                for (name in obj) {
                    value = obj[name];
                    if (value instanceof Array) {
                        for (i = 0; i < value.length; ++i) {
                            subValue = value[i];
                            fullSubName = name; // name + '[' + i + ']';
                            innerObj = {};
                            innerObj[fullSubName] = subValue;
                            query += toFormData(innerObj) + '&';
                        }
                    } else if (value instanceof Object) {
                        for (subName in value) {
                            subValue = value[subName];
                            fullSubName = name + '[' + subName + ']';
                            innerObj = {};
                            innerObj[fullSubName] = subValue;
                            query += toFormData(innerObj) + '&';
                        }
                    } else if (value !== undefined && value !== null) {
                        query += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&';
                    }
                }
                return query.length ? query.substr(0, query.length - 1) : query;
            }
            // 浏览器缓存设置
            // if (!$httpProvider.defaults.headers.get) {
            //     $httpProvider.defaults.headers.get = {};
            // }
            // $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
            // $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
            $httpProvider.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded';
            $httpProvider.defaults.transformRequest = [
                function (data) {
                    return angular.isObject(data) && String(data) !== '[object File]' ? toFormData(data) : data;
                },
            ];
        },
    ])
    .config([
        '$validationProvider',
        function ($validationProvider) {
            var expression = {
                // xssFormat2: function(value) {
                //     if (!value) {return true;}
                //     var invalidnum = 0;
                //     // 常见容易导致攻击的标签配置到黑名单
                //     var blackList = ['<img', '<script', '<body', '<iframe', '<frame', '<input', '<link', '<meta', '<table', '<div', '<xss', '<style', '<base', '<?import', '<a'];
                //     for (var i in blackList) {
                //         if (value.indexOf(blackList[i]) > -1) {
                //             invalidnum++;
                //             break;
                //         }
                //     }
                //     return !(invalidnum > 0);
                // },
                ip: function (value, scope, element, attrs, param) {
                    if (!value) {
                        return true;
                    }
                    var ip_REGEXP = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
                    return ip_REGEXP.test(value);
                },
                ips: /(\d{1,3}|\*)(\.(\d{1,3}|\*)){3}(,(\d{1,3}|\*)(\.(\d{1,3}|\*)){3})*/,
                sensitiveWords: function (value, scope, element, attrs, param) {
                    var flag = true;
                    angular.forEach(value.split('\n'), function (data, index, array) {
                        var reg = /^([a-zA-Z0-9\u4e00-\u9fa5]{1,50}),([^,< > / \ ' "]{0,50}),([12]{0,1})$|^([a-zA-Z0-9\u4e00-\u9fa5]{1,50}),([^,< > / \ ' "]{0,50})$|^([a-zA-Z0-9\u4e00-\u9fa5]{1,50}),([^,< > / \ ' "]{0,50}),$|^([a-zA-Z0-9\u4e00-\u9fa5]{1,50})$/;
                        // data.match(reg) ? "" : flag = false;
                        if (!data.match(reg)) {
                            flag = false;
                        }
                    });
                    return flag;
                },
                userName: function (value, scope, element, attrs, param) {
                    var flag = true;
                    if (value == 'admin' || value == 'system') {
                        flag = false;
                    }
                    return flag;
                },
                userNameChar: /^[\u4E00-\u9FA5A-Za-z][\u4E00-\u9FA5A-Za-z0-9_.\-]+$/,

                /* sperChnlIds: /^((([0-9]+,)*[0-9]+)|([0-9]*))$/,*/
                sperChnlIds: function (value, scope, element, attrs, param) {
                    if (!value) {
                        return true;
                    }
                    var sperChnlIds_REGEXP = /^((([0-9]+,)*[0-9]+)|([0-9]*))$/;
                    return sperChnlIds_REGEXP.test(value);
                },
                uniqueTime: function (value, scope, element, attrs, param) {
                    return value.length < 5;
                },
                posInt: function (value, scope, element, attrs, param) {
                    if (!value) {
                        return true;
                    }
                    var posInt_REGEXP = /^[1-9][0-9]*$/;
                    return posInt_REGEXP.test(value);
                },
                maxindex: function (value, scope, element, attrs, param) {
                    if (!value) {
                        return true;
                    }
                    return parseInt(value) <= param;
                },
                minindex: function (value, scope, element, attrs, param) {
                    if (!value) {
                        return true;
                    }
                    return parseInt(value) >= param;
                },
                maxwordlength: function (value, scope, element, attrs, param) {
                    if (!value) {
                        return true;
                    }
                    var newVal = value.replace(/<\/?[A-Za-z]+(.*?)>/g, '');
                    var len = 0;
                    for (var i = 0; i < newVal.length; i++) {
                        var data = newVal[i];
                        if (data.match(/[\u0000-\u00ff]/g)) {
                            len += 0.5;
                        } else if (data.match(/[\u4e00-\u9fa5]|[！￥……（）——【】：“‘？《》？、·。，]/g)) {
                            len++;
                        } else if (data.match(/[\uff00-\uffff]/g)) {
                            len++;
                        } else if (data.match(/ /g)) {
                            len += 0.5;
                        } else if (data.match(/　/g)) {
                            len++;
                        }
                    }
                    return len <= param;
                },
                maxbytes: function (value, scope, element, attrs, param) {
                    if (!value) {
                        return true;
                    }
                    var bytes = value.replace(/[^x00-xFF]/g, '**').length;
                    return bytes <= param;
                },
                areacode: function (value) {
                    var reg = /^0\d{2,3}$/;
                    return reg.test(value);
                },
                maxvalue: function (value, scope, element, attrs, param) {
                    if (!value) {
                        return true;
                    }
                    if (isNaN(value)) {
                        return false;
                    }
                    return Number(value) <= Number(param);
                },
                minvalue: function (value, scope, element, attrs, param) {
                    if (!value) {
                        return true;
                    }
                    if (isNaN(value)) {
                        return false;
                    }
                    return Number(value) >= Number(param);
                },
                price: function (value, scope, element, attrs, param) {
                    if (!value) {
                        return true;
                    }
                    var priceReg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
                    return priceReg.test(value);
                },
                noAt: function (value) {
                    if (!value) {
                        return true;
                    }
                    return value.indexOf('@') === -1;
                },
                startWithChar: function (value) {
                    if (!value) {
                        return true;
                    }
                    var reg = /^[a-zA-Z]+.*/gi;
                    return reg.test(value);
                },
                topicflag: function(value) {
                    if (!value) {
                        return true;
                    }
                    var topicReg = /^[^#]*?$/g;
                    return topicReg.test(value);
                }
            };
            var validMsg = {
                // xssFormat2: {
                //     error: '包含xss攻击字符',
                //     success: 'OK!'
                // },
                ip: {
                    error: 'IP格式不正确',
                    success: 'OK!',
                },
                ips: {
                    error: 'IP地址格式错误',
                    success: 'OK!',
                },
                sensitiveWords: {
                    error: '敏感词格式错误',
                    success: 'OK!',
                },
                userName: {
                    error: '用户名不能使用系统保留账号',
                    success: 'OK!',
                },
                userNameChar: {
                    error: '不符合用户名填写规则',
                    success: 'OK!',
                },
                sperChnlIds: {
                    error: '不符合填写规则',
                    success: 'OK!',
                },
                uniqueTime: {
                    error: '排重时间不能大于5位数',
                    success: 'OK!',
                },
                posInt: {
                    error: '只能填写正整数！',
                    success: 'OK!',
                },
                maxindex: {
                    error: '超过最大序号数',
                    success: 'OK!',
                },
                minindex: {
                    error: '小于最小序号数',
                    success: 'OK!',
                },
                maxwordlength: {
                    error: '长度不能超过50个字符',
                    success: 'OK!',
                },
                maxbytes: {
                    error: '字节数超出限制',
                    success: 'OK!',
                },
                areacode: {
                    error: '电话区号格式错误',
                    success: 'OK!',
                },
                maxvalue: {
                    error: '输入的值太大了',
                    success: 'OK!',
                },
                minvalue: {
                    error: '输入的值太小了',
                    success: 'OK!',
                },
                price: {
                    error: '请输入有效价格',
                    success: 'OK!',
                },
                leftoverText: {
                    error: '请选择标签',
                    success: 'OK!',
                },
                noAt: {
                    error: '不能包含@符号',
                    success: 'OK!'
                },
                startWithChar: {
                    error: '必须以字母开头',
                    success: 'OK!'
                },
                topicflag: {
                    error: '不允许输入#号',
                    success: 'OK!',
                }
            };
            $validationProvider
                .setExpression(expression) // set expression
                .setDefaultMsg(validMsg); // set valid message
        },
    ])
    .config(
        [
            '$sceProvider',
            function ($sceProvider) {
                $sceProvider.enabled(false);
            }
        ]
    ).config(['localStorageServiceProvider', function (localStorageServiceProvider) {
        localStorageServiceProvider
            .setPrefix('ls'); // 设置缓存前缀
    }]);
app.run([
    '$timeout',
    '$rootScope',
    '$location',
    'loginService',
    '$transitions',
    'messagePublishService',
    '$sessionStorage',
    'localStorageService',
    'editingCenterService',
    'noticeWindowService',
    'publicToolService',
    function ($timeout, $rootScope, $location, loginService, $transitions, messagePublishService, $sessionStorage, localStorageService, editingCenterService, noticeWindowService, publicToolService) {
        $rootScope.status = {
            basicAccess: '', // 顶部导航权限控制
            defaultListRight: '', // 系统默认页面列表访问权限
        };
        $rootScope.memorySwitch = {
            global: true
        };
        $transitions.onStart({}, function (trans) {
            if (!$rootScope.memorySwitch.global) {
                localStorageService.set('global.state', {});
                return;
            }
            var toState = trans.to();
            var toRoute = toState.name;
            var fromState = trans.from();
            var toParams = trans.params('to'); // 将要去的路由参数
            var fromParams = trans.params('from'); // 将要离开的路由参数
            var stateObj = localStorageService.get('global.state') || {};
            var user = $sessionStorage.get('curUserInfo') || {};
            var userId = user.ID;
            if (!userId) {
                return;
            }
            var stateArr = ['front.editctr', 'front.resourcectrl', 'front.networksource']; // 暂时只记采编中心和版权资源
            var toArr = toState.name.split('.'); // 将要去的路由
            var fromArr = fromState.name.split('.'); // 离开的路由
            var name = fromArr[0] + '.' + fromArr[1];
            if ((stateArr.indexOf(name) !== -1 || stateArr.indexOf(toState.name) !== -1) && fromArr.length > 1) { // 暂时不管刚登录时的情形
                if (!stateObj[userId]) { // 按用户来记
                    stateObj[userId] = {};
                }
                if (fromState.name.indexOf('front.editctr') !== -1 && fromArr.length === 4) { // 采编列表页回显筛选条件
                    editingCenterService.memoryCondition(userId, stateObj);
                }
                if (toArr.length === 2) { // 切换模块时重定向
                    if (fromArr.length > 2) {
                        stateObj[userId][name] = { url: fromState.name, query: fromParams };
                        localStorageService.set('global.state', stateObj);
                    }
                    if (stateObj[userId][toState.name] && stateArr.indexOf(toState.name) !== -1) { // 如果路由只有两层，会发生无限重定向该位置的现象，故加此判断限制为采编、版权和网络
                        return trans.router.stateService.target(stateObj[userId][toState.name].url, stateObj[userId][toState.name].query);
                    }
                } else if (toArr.length >= 4) {
                    $timeout(function () {
                        var $dom = $('.sidebar_nav_content');
                        if (!$dom.length) { // 当切换大模块时，导航栏还没加载出来，此时获取不到index
                            return;
                        }
                        var index = $dom.find('.active').parent().index();
                        name = toArr[2];
                        if (toRoute.indexOf('front.editctr') === -1) {
                            if (toArr.length === 4) { // 采编和版权的url是四层
                                toArr.length = 3;
                            } else { // 网络资源的url是5层
                                toArr.length = 4;
                                var _name = toArr[0] + '.' + toArr[1] + '.' + toArr[2];
                                stateObj[userId][_name] = { url: toRoute, query: toParams, index: index }; // 为了记录版权资源下拉导航菜单在那个位置
                            }
                            name = toArr.join('.');
                        }
                        stateObj[userId][name] = { url: toRoute, query: toParams, index: index };
                        localStorageService.set('global.state', stateObj);
                    });
                }
            }
        });
        $transitions.onSuccess({}, function (trans) {
            var toRoute = trans.to().name;
            var toArr = toRoute.split('.');
            if (toRoute.indexOf('front.editctr') !== -1 && toArr.length === 4) {
                editingCenterService.echoCondition();
            }
        });
        getCommonConfig();
        getEditPageConfig();
    
        /**
         * [dealStrongWindowNewsDaily description]获取新闻日历的弹框 并把用户信息带过去
         * @param   {[type]}  data  [data description]
         * @return  {[type]}        [return description]
         */
        function dealStrongWindowNewsDaily(data) {
            var strongWindowNewsDailyInfo = $sessionStorage.get('global.strongWindowNewsDailyInfo');
            if (!strongWindowNewsDailyInfo) {
                noticeWindowService.getNewsDailyInfo(data);
            }
        }
        loginService.getCurrLoginUser().then(function (data) {
            $timeout(() => {
                messagePublishService.publish('CurrLoginUserHaveGet');
            }, 1000);
            // 我在这里调用新闻日历提醒 减少一次获取当前用户的接口
            dealStrongWindowNewsDaily(data);
            // 发送提醒弹框
            var sendNoticeOnlogin = $sessionStorage.get('global.sendNoticeOnlogin');
            if (!sendNoticeOnlogin) {
                noticeWindowService.sendNoticeOnlogin(data);
            }
            var mlfCachedUser = $sessionStorage.get('mlfCachedUser');
            if (mlfCachedUser) {
                mlfCachedUser.UserName = data.TRUENAME || data.USERNAME;
            } else {
                mlfCachedUser = {};
                mlfCachedUser.UserName = data.TRUENAME || data.USERNAME;
            }
            $sessionStorage.set('mlfCachedUser', mlfCachedUser);
            $sessionStorage.set('currLoginUser', mlfCachedUser.UserName);
            loginService.selectGroup();
            setLoginedMark(data);
            // loginService.isNeedResetPassword().then(
            //     () => {
            //         loginService.forceResetPassword().then(() => {
                    
            //         });
            //     },
            //     () => {
            //         loginService.selectGroup();
            //         setLoginedMark(data);
            //     }
            // );
        });

        /**
         * [getGlobalConfig description] 获取采编中心与采编下稿件编辑页面的配置
         * @return  {[type]}  [return description]
         */
        function getEditPageConfig() {
            let urlPath = $location.path().split('/');
            let firstUrlPath = urlPath[1];
            if (firstUrlPath && firstUrlPath !== 'front' && firstUrlPath !== 'manageconfig') { // 表示是采编稿件编辑页面
                publicToolService.queryModeconfiguration(); // 因为采编新开页面具有很多配置项，为了方便调用写在这里
            }
        }

        /**
         * [getCommonConfig description] 获取系统的通用配置 (如页头、页尾等)
         * @return  {[type]}  [return description]
         */
        function getCommonConfig() {
            publicToolService.queryModeconfiguration('commonInfo');
        }

        /**
         * [setLoginedMark description] 设置登录标识
         * @param   {[object]}  userInfo  [userInfo description] 当前用户信息
         * @return  {[type]}              [return description]
         */
        function setLoginedMark(userInfo){
            // if (localStorageService.get('global.loginMark')) {return;}
            localStorageService.set('global.loginMark', {
                [userInfo.ID]: 'hasLogin'
                // hasLogin: true
            });
        }
    },
]);

app.value('cgBusyDefaults', {
    message: '数据加载中...',
    backdrop: true,
    delay: 0,
    minDuration: 100,
    wrapperClass: 'mlf-busy',
});
app.value('versionCtrl', {
    isDebug: false, // 测试版
    isOffical: false, // 正式版,
    isDev: true, // 开发版
    versionNumber: 0.1 + '_version=0001',
});
// 定义一个全局的名称：石榴云。以便于后面名称的修改
app.value('nameChange', {
    globalName: '石榴云',
});
app.value('configuration', {
    IM: {
        value: {
            isShow: true,
            mode: 'general',
        }
    },
    avUploader: {
        value: {
            mode: 'general'
        }
    },
    supportCreation: { // 稿件左侧辅助写作
        value: {
            'chuanzuozhou': true, // 创作轴
            'zhinengpeitu': true, // 智能配图
            'zhutiyanzhan': true, // 稿件背
            'onlinesearch': true, // 在线搜索
            'gaojianbeijing': true, // 稿件背景
            'wenzhangjiaodui': true // 文章校对
        }
    }
});
angular.element(document).ready(function () {
    angular.bootstrap(document, ['app']);
});
